<template>
  <div @click="visible = true">
    <slot></slot>
    <a-modal
      v-model="visible"
      width="80vw"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-pcb-converter-modal"
    >
      <div class="c-pcb-converter">
        <img ref="cropper" :src="image" class="cropper" />
        <label v-if="!image" class="cropper-upload" for="upload">
          <div class="upload-box">
            <i class="iconfont iconupload-folder" />
          </div>
          <span v-html="$t('light.supportFormat', ['100*38'])"></span>
          <input
            id="upload"
            type="file"
            @change="onUpload"
            :value="image"
            accept="image/gif, image/png, image/jpeg"
          />
        </label>
        <div class="buttons" v-if="image">
          <md-button class="button" @click="image = null">
            {{ $t("back") }}
          </md-button>
          <md-button class="button" v-if="image" @click="onConversion">
            {{ $t("conversion") }}
          </md-button>
        </div>
        <i class="close iconfont iconclose-o" @click="visible = false" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import Cropper from "cropperjs";
import GifFrames from "gif-frames";
import "cropperjs/dist/cropper.css";

export default {
  name: "CPcbConverter",
  data() {
    return {
      visible: false,
      image: null,
      cropper: null,
      coords: [
        { key: "LED_REC", x: 20, y: 25 },
        { key: "LED_ESC", x: 20, y: 25 },
        { key: "LED_F1", x: 100, y: 25 },
        { key: "LED_F2", x: 165, y: 25 },
        { key: "LED_F3", x: 230, y: 25 },
        { key: "LED_F4", x: 295, y: 25 },
        { key: "LED_F5", x: 375, y: 25 },
        { key: "LED_F6", x: 440, y: 25 },
        { key: "LED_F7", x: 505, y: 25 },
        { key: "LED_F8", x: 565, y: 25 },
        { key: "LED_F9", x: 645, y: 25 },
        { key: "LED_F10", x: 710, y: 25 },
        { key: "LED_F11", x: 775, y: 25 },
        { key: "LED_F12", x: 840, y: 25 },
        { key: "LED_DELETE", x: 920, y: 25 },
        // 14
        { key: "LED_GAT", x: 20, y: 100 },
        { key: "LED_1", x: 85, y: 100 },
        { key: "LED_2", x: 150, y: 100 },
        { key: "LED_3", x: 215, y: 100 },
        { key: "LED_4", x: 275, y: 100 },
        { key: "LED_5", x: 340, y: 100 },
        { key: "LED_6", x: 405, y: 100 },
        { key: "LED_7", x: 470, y: 100 },
        { key: "LED_8", x: 535, y: 100 },
        { key: "LED_9", x: 600, y: 100 },
        { key: "LED_0", x: 660, y: 100 },
        { key: "LED_MIS", x: 725, y: 100 },
        { key: "LED_EQU", x: 790, y: 100 },
        { key: "LED_BACKSPACE", x: 890, y: 100 },
        // 28
        { key: "LED_TAB", x: 35, y: 160 },
        { key: "LED_Q", x: 115, y: 160 },
        { key: "LED_W", x: 180, y: 160 },
        { key: "LED_E", x: 245, y: 160 },
        { key: "LED_R", x: 310, y: 160 },
        { key: "LED_T", x: 375, y: 160 },
        { key: "LED_Y", x: 440, y: 160 },
        { key: "LED_U", x: 500, y: 160 },
        { key: "LED_I", x: 565, y: 160 },
        { key: "LED_O", x: 630, y: 160 },
        { key: "LED_P", x: 695, y: 160 },
        { key: "LED_OQO", x: 760, y: 160 },
        { key: "LED_EQO", x: 825, y: 160 },
        { key: "LED_BSL", x: 900, y: 160 },
        // 42
        { key: "LED_CAPSLOCK", x: 45, y: 225 },
        { key: "LED_A", x: 135, y: 225 },
        { key: "LED_S", x: 195, y: 225 },
        { key: "LED_D", x: 260, y: 225 },
        { key: "LED_F", x: 325, y: 225 },
        { key: "LED_G", x: 390, y: 225 },
        { key: "LED_H", x: 450, y: 225 },
        { key: "LED_J", x: 520, y: 225 },
        { key: "LED_K", x: 580, y: 225 },
        { key: "LED_L", x: 645, y: 225 },
        { key: "LED_COL", x: 710, y: 225 },
        { key: "LED_CC", x: 775, y: 225 },
        { key: "LED_ENTER", x: 880, y: 225 },
        { key: "LED_PAGEDOWN", x: 985, y: 225 },
        // 56
        { key: "LED_LEFTSHIFT", x: 60, y: 285 },
        { key: "LED_Z", x: 165, y: 285 },
        { key: "LED_X", x: 230, y: 285 },
        { key: "LED_C", x: 295, y: 285 },
        { key: "LED_V", x: 360, y: 285 },
        { key: "LED_B", x: 420, y: 285 },
        { key: "LED_N", x: 485, y: 285 },
        { key: "LED_M", x: 550, y: 285 },
        { key: "LED_CMA", x: 615, y: 285 },
        { key: "LED_DOT", x: 675, y: 285 },
        { key: "LED_SL", x: 740, y: 285 },
        { key: "LED_PAGEUP", x: 985, y: 160 },
        { key: "LED_END", x: 985, y: 100 },
        { key: "LED_HOME", x: 985, y: 25 },
        // 70
        { key: "LED_LEFTCTRL", x: 30, y: 350 },
        { key: "LED_LEFTGUI", x: 110, y: 350 },
        { key: "LED_LEFTALT", x: 190, y: 350 },
        { key: "LED_LSPACEBAR", x: 290, y: 350 },
        { key: "LED_SPACEBAR", x: 430, y: 350 },
        { key: "LED_RSPACEBAR", x: 565, y: 350 },
        { key: "LED_FN", x: 670, y: 350 },
        { key: "LED_RIGHTCTRL", x: 750, y: 350 },
        { key: "LED_LEFT", x: 850, y: 350 },
        { key: "LED_DOWN", x: 915, y: 350 },
        { key: "LED_RIGHT", x: 985, y: 350 },
        { key: "LED_RIGHTSHIFT", x: 830, y: 285 },
        { key: "LED_UP", x: 915, y: 285 },
      ],
    };
  },
  methods: {
    onUpload(e) {
      const file = e.target.files[0];
      if (file && file.type.includes("image/")) {
        if (file.type === "image/gif") {
          this.buildFrames(file);
        } else {
          const image = new Image();
          image.src = URL.createObjectURL(file);
          image.onload = () => {
            this.image = URL.createObjectURL(file);
          };
        }
      } else {
        e.target.value = null;
        this.$message.info(this.$t("light.fileErrorInfo"));
      }
    },
    onConversion() {
      const canvas = this.cropper.getCroppedCanvas({
        width: 50,
        height: 19,
      });
      this.$emit("change", { RGB: this.getRGB(canvas) });
      this.$message.destroy();
      this.visible = false;
    },
    getRGB(canvas) {
      const { width, height } = canvas;
      const context = canvas.getContext("2d");
      const imageData = context.getImageData(0, 0, width, height);
      const ratio = width / 1000;
      let RGB = [];

      this.coords.map(({ x, y }) => {
        let index =
          Math.floor(
            Math.floor(y * ratio) * 1000 * ratio + Math.floor(x * ratio)
          ) * 4;
        index = index - (index % 4);
        index =
          index >= imageData.data.length ? imageData.data.length - 4 : index;
        let r = imageData.data[index].toString(16);
        let g = imageData.data[index + 1].toString(16);
        let b = imageData.data[index + 2].toString(16);
        r = (r.length === 1 ? "0" : "") + r;
        g = (g.length === 1 ? "0" : "") + g;
        b = (b.length === 1 ? "0" : "") + b;
        RGB.push("#" + r + g + b);
      });
      return RGB;
    },
    buildFrames(file) {
      this.$message.info(this.$t("light.build"), 60000);
      GifFrames({
        url: URL.createObjectURL(file),
        frames: "all",
        outputType: "canvas",
      })
        .then((frameData) => {
          let frames = [];
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = 50;
          canvas.height = 19;

          const width = frameData[0].getImage().width;
          const height = (width * canvas.height) / canvas.width;
          const sy = (frameData[0].getImage().height - height) / 2;

          frameData.map((item) => {
            context.drawImage(
              item.getImage(),
              0,
              sy,
              width,
              height,
              0,
              0,
              canvas.width,
              canvas.height
            );
            const frameRGB = this.getRGB(canvas);
            while (frameRGB.length) {
              frames.push({
                frameIndex: frames.length + 1,
                frameRGB: frameRGB.splice(0, 84),
              });
            }
          });
          this.$emit("change", { frames });
          this.$message.destroy();
          this.visible = false;
        })
        .catch(() => {
          this.$message.destroy();
        });
    },
  },
  watch: {
    image(image) {
      if (image) {
        setTimeout(() => {
          this.cropper = new Cropper(this.$refs.cropper, {
            viewMode: 1,
            dragMode: "move",
            aspectRatio: 1000 / 375,
            minCropBoxWidth: 100,
            background: false,
            toggleDragModeOnDblclick: false,
          });
        }, 500);
      } else {
        this.cropper && this.cropper.destroy();
      }
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.cropper && this.cropper.destroy();
      this.image = null;
    });
  },
};
</script>
<style lang="scss" scoped>
.c-pcb-converter {
  @include flex-center;
  width: 1250px;
  height: 800px;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  .cropper {
    width: 100%;
    height: 100%;
    visibility: hidden;
  }

  .cropper-container {
    .cropper-view-box {
      outline: 2px solid $primary-color;
    }
    .cropper-modal {
      opacity: 0.25;
    }
    .cropper-point,
    .cropper-line {
      background-color: $primary-color;
    }
  }

  .cropper-upload {
    @include flex-center;
    width: 100%;
    flex-direction: column;
    position: absolute;
    top: 200px;
    left: 0;
    cursor: pointer;

    .upload-box {
      @include flex-center;
      width: 800px;
      height: 304px;
      border: 2px solid $primary-color;
      color: $primary-color;
      margin-bottom: 20px;

      i {
        font-size: 60px;
      }
    }

    input {
      display: none;
    }

    span {
      color: #ffffff;
      font-size: 20px;
    }
  }

  .buttons {
    @include flex-center;
    width: 100%;
    position: absolute;
    bottom: 100px;
    left: 0;

    .button {
      width: 450px;
      height: 53px;
      background-color: $primary-color;
      border-radius: 5px;
      font-size: 20px;
      text-transform: none;

      & + .button {
        margin-left: 100px;
      }
    }
  }

  .close {
    @include icon-hover;
    font-size: 40px;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
